<aside class="vertical-menu" aria-label="Menu articles">
  <p class="menu-title">{{ title }}</p>
  <nav>
    @for (group of groups; track group.label; let i = $index) {
      <app-vertical-menu-group
        [group]="group"
        [activePath]="activePath"
        [expanded]="expandedIndex === i"
        (toggled)="toggleGroup(i)"
      ></app-vertical-menu-group>
    }
  </nav>
</aside>
